import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { checkNull, downloadFileFromUrl } from "../../helpers";
import { authServices } from "../../services";
import {
  changeTaxEndApi,
  companySettingData,
  downloadStaffTemplate,
  getFinanceGeneralSettings,
  getProfileDetailsApi,
  getSetupDetails,
  toggleSettingAccModal,
  userLogout,
} from "../actions";
import {
  showNotificationWithTimeout,
  showAlert,
} from "../actions/toastActions";
import * as actionTypes from "../actionTypes";

let errMsg = "Something went wrong!";

function* getRegisterDetails(action) {
  const res = yield call(authServices.getRegisterDetails, action?.query);
  if (res) {
    if (res?.status) {
      yield put({
        type: actionTypes.GET_REGISTER_DETAILS_SUCCEEDED,
        payload: {
          register_details: res?.data,
        },
      });
    } else {
      toast.error(res?.message ?? errMsg);
    }
  } else {
    toast.error(errMsg);
  }
}

function* saveRegisterDetails(action) {
  const res = yield call(authServices.saveRegisterDetails, action.payload);
  const errors = yield select((state) => state?.authReducer?.errors);
  if (res) {
    if (res?.status) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put({
        type: actionTypes.SAVE_REGISTER_DETAILS_SUCCEEDED,
        payload: {
          is_registered: true,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* saveLoginDetails(action) {
  const res = yield call(authServices.saveLoginDetails, action.payload);
  const errors = yield select((state) => state?.authReducer?.errors);
  if (res) {
    if (res?.status && res?.data?.token && res?.data?.user_details) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put({
        type: actionTypes.SAVE_LOGIN_DETAILS_SUCCEEDED,
        payload: {
          user_details: res?.data?.user_details,
          user_token: res?.data?.token ?? null,
        },
      });
    } else {
      yield put(showAlert("Alert", `${res?.message ?? errMsg}`));
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showAlert("Alert", `${errMsg}`));
    // toast.error(errMsg);
  }
}
function* saveUserActivation(action) {
  const res = yield call(authServices.saveUserActivation, action.payload);
  const errors = yield select((state) => state?.authReducer?.errors);
  if (res) {
    if (res?.status && res?.data?.token && res?.data?.user_details) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put({
        type: actionTypes.SAVE_LOGIN_DETAILS_SUCCEEDED,
        payload: {
          user_details: res?.data?.user_details,
          user_token: res?.data?.token ?? null,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* saveForgotDetails(action) {
  const res = yield call(authServices.saveForgotDetails, action.payload);
  if (res) {
    if (res?.status) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put({
        type: actionTypes.SAVE_FORGOT_DETAILS_SUCCEEDED,
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* getSetupDetailsApi(action) {
  const res = yield call(authServices.getSetupDetails, action?.query);
  if (res) {
    if (res?.status && res?.data) {
      const payload = {};
      payload.setup_wizard_details = res?.data;
      if (checkNull(res?.data?.staff_data, false)) {
        payload.upload_staff = res?.data?.staff_data;
      }
      if (checkNull(res?.data?.payee_data, false)) {
        payload.upload_payee = res?.data?.payee_data;
      }
      yield put({
        type: actionTypes.GET_SETUP_DETAILS_SUCCEEDED,
        payload,
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getStateDetails(action) {
  const res = yield call(authServices.getStateDetails, action?.query);
  if (res) {
    if (res?.status && checkNull(res?.data?.states, false)) {
      yield put({
        type: actionTypes.GET_STATE_SUCCEEDED,
        payload: {
          states: res?.data?.states,
        },
      });
    } else {
      yield put({
        type: actionTypes.GET_STATE_FAILED,
      });
    }
  } else {
    yield put({
      type: actionTypes.GET_STATE_FAILED,
    });
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getStartedDetails(action) {
  const res = yield call(authServices.getStartedDetails, action?.query);
  if (res) {
    if (res?.status && res?.data) {
      yield put({
        type: actionTypes.GET_STARTED_DETAILS_SUCCEEDED,
        payload: {
          setup_wizard_details: res?.data,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveRequestApi(action) {
  const res = yield call(authServices.saveRequestApi, action.payload);
  if (res) {
    if (res?.status) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      // yield put({
      //   type: actionTypes.SAVE_REQUEST_API_SUCCEEDED,
      // });
    } else {
      yield put(showAlert("Alert", `${res?.message ?? errMsg}`));
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* getProfileDetails(action) {
  const res = yield call(authServices.getProfileDetails, action?.query);
  if (res) {
    if (res?.status) {
      yield put({
        type: actionTypes.GET_PROFILE_DETAILS_SUCCEEDED,
        payload: {
          user_details: res?.data,
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveSetupZero(action) {
  let res = false;
  switch (action?.step) {
    case "zero":
      res = yield call(authServices.saveSetupZero, action.payload);
      break;
    case "one":
      res = yield call(authServices.saveSetupOne, action.payload);
      break;
    case "two":
      res = yield call(authServices.saveSetupTwo, action.payload);
      break;
    case "three":
      res = yield call(authServices.saveSetupThree, action.payload);
      break;
    case "four":
      res = yield call(authServices.saveSetupFour, action.payload);
      break;
    case "five":
      res = yield call(authServices.saveSetupFive, action.payload);
      break;
    case "six":
      res = yield call(authServices.saveSetupSix, action.payload);
      break;
    case "seven":
      res = yield call(authServices.saveSetupSeven, action.payload);
      break;
    case "eight":
      res = yield call(authServices.saveSetupEight, action.payload);
      break;
    case "nine":
      res = yield call(authServices.saveSetupNine, action.payload);
      break;
    default:
      break;
  }
  if (res) {
    if (res?.status) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      if (action?.isLogout == true) {
        yield put(userLogout());
      } else {
        yield put(getProfileDetailsApi());
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* saveGettingStarted(action) {
  const res = yield call(authServices.saveGettingStarted, action.payload);
  if (res) {
    if (res?.status) {
      if (res?.message) {
        // toast.success(res?.message);
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put(getProfileDetailsApi());
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      // toast.error(res?.message ?? errMsg);
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
    // toast.error(errMsg);
  }
}

function* checkTaxYear(action) {
  const taxEndApi = yield select(
    (state) => state?.authReducer?.run_tax_end_date_api
  );
  const res = yield call(authServices.checkTaxYear, action.payload);
  console.log("CHECK_TAX_YEAR_SUCCEEDED", res);
  if (res?.data) {
    yield put({
      type: actionTypes.CHECK_TAX_YEAR_SUCCEEDED,
      payload: {
        tax_year_res: res?.data,
        tax_end_date_start_from: res?.data?.return == 2 ? 0 : 1,
      },
    });
  } else {
    yield put({
      type: actionTypes.CHECK_TAX_YEAR_FAILED,
    });
  }
  yield put(
    changeTaxEndApi({
      run_tax_end_date_api: taxEndApi == null ? true : !taxEndApi,
    })
  );
}
function* getTaxYearEndDate(action) {
  const startFrom = yield select(
    (state) => state?.authReducer?.tax_end_date_start_from
  );
  const res = yield call(authServices.getTaxYearEndDate, {
    ...action.payload,
    isBeforeOrAfter: parseInt(startFrom),
  });
  console.log("GET_TAX_END_DATE_SUCCEEDED", res);

  if (res?.data) {
    yield put({
      type: actionTypes.GET_TAX_END_DATE_SUCCEEDED,
      payload: {
        tax_end_date_res: res?.data,
      },
    });
  } else {
    yield put({
      type: actionTypes.GET_TAX_END_DATE_FAILED,
    });
  }
}

function* saveAccountingPeriod(action) {
  yield put({ type: actionTypes.SETTING_MODAL_START_LOADING });
  let res = false;
  if (action.payload?.ap_id !== "") {
    res = yield call(authServices.editAccountingPeriod, action.payload);
  } else {
    res = yield call(authServices.saveAccountingPeriod, action.payload);
  }
  if (res) {
    if (res?.status) {
      if (res?.message) {
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      if (action.fromType == "companySettings") {
        yield put(companySettingData(action?.formTypeId));
      } else if (action.fromType == "finance") {
        yield put(getFinanceGeneralSettings());
      } else {
        yield put(getSetupDetails(2));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put({ type: actionTypes.SETTING_MODAL_STOP_LOADING });
  yield put(toggleSettingAccModal(false));
}

function* savePayrollFrequency(action) {
  let res = false;
  if (action.payload?.id !== "") {
    res = yield call(authServices.editPayrollFrequency, action.payload);
  } else {
    res = yield call(authServices.savePayrollFrequency, action.payload);
  }
  if (res) {
    if (res?.status) {
      if (res?.message) {
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put(getSetupDetails(3));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getAccrualTypesDetail(action) {
  const laborSettingEss = yield select(
    (state) => state?.authReducer?.labor_setting_essentials
  );
  const res = yield call(authServices.getAccrualTypes, action.query);

  if (res?.data) {
    yield put({
      type: actionTypes.GET_ACCRUAL_TYPE_SUCCEEDED,
      payload: {
        ...laborSettingEss,
        accrual_types: res?.data,
      },
    });
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* saveLaborRuleDetail(action) {
  let res = false;

  switch (action.stats) {
    case "leave":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editLeaveRule, action.payload);
      } else {
        res = yield call(authServices.saveLeaveRule, action.payload);
      }
      break;
    case "overtime":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editOvertimeRule, action.payload);
      } else {
        res = yield call(authServices.saveOvertimeRule, action.payload);
      }
      break;
    case "meal":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editMealRule, action.payload);
      } else {
        res = yield call(authServices.saveMealRule, action.payload);
      }
      break;
    case "incentive":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editIncentiveRule, action.payload);
      } else {
        res = yield call(authServices.saveIncentiveRule, action.payload);
      }
      break;
    case "blackout":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editBlackoutRule, action.payload);
      } else {
        res = yield call(authServices.saveBlackoutRule, action.payload);
      }
      break;
    case "performance":
      if (action.payload?.id !== "") {
        res = yield call(authServices.editPerformanceRule, action.payload);
      } else {
        res = yield call(authServices.savePerformanceRule, action.payload);
      }
      break;
    default:
      break;
  }

  if (res) {
    if (res?.status) {
      if (res?.message) {
        yield put(
          showNotificationWithTimeout(
            `${res?.message ? res.message : "success"}`,
            "success"
          )
        );
      }
      yield put(getSetupDetails(3));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* deleteLaborRuleDetail(action) {
  const res = yield call(authServices.deleteLaborRule, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
    yield put(getSetupDetails(3));
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* saveUploadStaff(action) {
  const res = yield call(authServices.saveUploadStaff, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
    yield put({
      type: actionTypes.SAVE_UPLOAD_STAFF_SUCCEEDED,
      payload: {
        upload_staff: res?.data ?? null,
      },
    });
  } else {
    yield put({
      type: actionTypes.SAVE_UPLOAD_STAFF_FAILED,
    });
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}
function* downloadStaffTemplateDetail(action) {
  const res = yield call(authServices.downloadStaffTemplate, action.query);

  if (res?.status && res?.data?.file_path && res?.data?.file_name) {
    yield call(downloadFileFromUrl, res?.data?.file_path, res?.data?.file_name);
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}
function* downloadPayeeTemplateDetail(action) {
  const res = yield call(authServices.downloadPayeeTemplate, action.query);

  if (res?.status && res?.data?.file_path && res?.data?.file_name) {
    yield call(downloadFileFromUrl, res?.data?.file_path, res?.data?.file_name);
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}
function* saveUploadPayee(action) {
  const res = yield call(authServices.saveUploadPayee, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
    yield put({
      type: actionTypes.SAVE_UPLOAD_PAYEE_SUCCEEDED,
      payload: {
        upload_payee: res?.data ?? null,
      },
    });
  } else {
    yield put({
      type: actionTypes.SAVE_UPLOAD_PAYEE_FAILED,
    });
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}
function* applyPromoWizard(action) {
  const res = yield call(authServices.applyPromoWizard, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
  yield put(getSetupDetails(9));
}
function* removePromoWizard(action) {
  const res = yield call(authServices.removePromoWizard, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
  yield put(getSetupDetails(9));
}

function* removeUploadStaff(action) {
  const res = yield call(authServices.removeUploadStaff, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
    yield put({
      type: actionTypes.SAVE_UPLOAD_STAFF_FAILED,
    });
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* removeUploadPayee(action) {
  const res = yield call(authServices.removeUploadPayee, action.payload);

  if (res?.status) {
    if (res?.message) {
      yield put(
        showNotificationWithTimeout(
          `${res?.message ? res.message : "success"}`,
          "success"
        )
      );
    }
    yield put({
      type: actionTypes.SAVE_UPLOAD_PAYEE_FAILED,
    });
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* backButtonHandler(action) {
  const userDetails = yield select((state) => state?.authReducer?.user_details);
  let step = action.tab;

  if (userDetails?.user?.merchant?.wizard_last_step) {
    const childCheckArr = ["tab3", "tab5", "tab6"];

    let lastStep = userDetails?.user?.merchant?.wizard_last_step;
    if (lastStep.indexOf("tab") > -1) {
      lastStep = lastStep.replace(/tab/gi, "");
      console.log("tabtabtab", lastStep);
      if (parseInt(lastStep) > 0) {
        if (
          userDetails?.user?.merchant?.parent_merchant_id > 0 &&
          childCheckArr.includes(userDetails?.user?.merchant?.wizard_last_step)
        ) {
          if (parseInt(lastStep) > 3) {
            lastStep = 4;
          } else {
            lastStep = 2;
          }
        } else {
          lastStep = parseInt(lastStep) - 1;
        }
        step = `tab${lastStep}`;
      }
    }
  }
  const payload = {
    wizard_last_step: step,
  };
  const res = yield call(authServices.backButtonHandler, payload);
  if (res?.status) {
    yield put(getProfileDetailsApi());
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* authSaga() {
  yield takeLatest(actionTypes.GET_REGISTER_DETAILS, getRegisterDetails);
  yield takeLatest(actionTypes.SAVE_REGISTER_DETAILS, saveRegisterDetails);
  yield takeLatest(actionTypes.SAVE_LOGIN_DETAILS, saveLoginDetails);
  yield takeLatest(actionTypes.SAVE_FORGOT_DETAILS, saveForgotDetails);
  yield takeLatest(actionTypes.GET_SETUP_DETAILS, getSetupDetailsApi);
  yield takeLatest(actionTypes.GET_STARTED_DETAILS, getStartedDetails);
  yield takeLatest(actionTypes.SAVE_REQUEST_API, saveRequestApi);
  yield takeLatest(actionTypes.GET_PROFILE_DETAILS, getProfileDetails);
  yield takeLatest(actionTypes.SAVE_SETUP_WIZARD_FORM, saveSetupZero);
  yield takeLatest(actionTypes.SAVE_GETTING_STARTED, saveGettingStarted);
  yield takeLatest(actionTypes.CHECK_TAX_YEAR, checkTaxYear);
  yield takeLatest(actionTypes.GET_TAX_END_DATE, getTaxYearEndDate);
  yield takeLatest(actionTypes.SAVE_ACCOUNTING_PERIOD, saveAccountingPeriod);
  yield takeLatest(actionTypes.SAVE_PAYROLL_FREQ, savePayrollFrequency);
  yield takeLatest(actionTypes.GET_ACCRUAL_TYPE, getAccrualTypesDetail);
  yield takeLatest(actionTypes.SAVE_LABOR_RULE, saveLaborRuleDetail);
  yield takeLatest(actionTypes.SAVE_UPLOAD_STAFF, saveUploadStaff);
  yield takeLatest(actionTypes.DELETE_LABOR_RULE, deleteLaborRuleDetail);
  yield takeLatest(
    actionTypes.DOWNLOAD_STAFF_TEMP,
    downloadStaffTemplateDetail
  );
  yield takeLatest(
    actionTypes.DOWNLOAD_PAYEE_TEMP,
    downloadPayeeTemplateDetail
  );
  yield takeLatest(actionTypes.SAVE_UPLOAD_PAYEE, saveUploadPayee);
  yield takeLatest(actionTypes.BACK_BTN_HANDLER, backButtonHandler);
  yield takeLatest(actionTypes.APPLY_PROMO_WIZARD, applyPromoWizard);
  yield takeLatest(actionTypes.REMOVE_PROMO_WIZARD, removePromoWizard);
  yield takeLatest(actionTypes.REMOVE_UPLOAD_STAFF, removeUploadStaff);
  yield takeLatest(actionTypes.REMOVE_UPLOAD_PAYEE, removeUploadPayee);
  yield takeLatest(actionTypes.USER_ACTIVATION, saveUserActivation);
  yield takeLatest(actionTypes.GET_STATE, getStateDetails);
}

export default authSaga;
